<template lang="pug">
  b-container.mb-4(fluid)
    b-card.card-inactive.mb-0(v-if="!activePlan")
      b-row.align-items-center
        b-col.text-center(cols="12")
          h4 Estás usando la versión gratuita de Konverza
          p.text-secondary Contrata un Plan Ilimitado y disfruta de increíbles beneficios exclusivos
          b-img(src="@/assets/ilustrations/upgrade.png", style="width:100%;max-width:300px;")
          .text-center.mb-2
            check-circle-icon.icon-sm.mr-3.text-primary
            span Conexión con Whatsapp*
          .text-center.mb-2
            check-circle-icon.icon-sm.mr-3.text-primary
            span Soporte técnico dedicado
          .text-center.mb-2
            check-circle-icon.icon-sm.mr-3.text-primary
            span Carga de productos ilimitada
          .text-center.mb-2
            check-circle-icon.icon-sm.mr-3.text-primary
            span Comisión por venta del 3.5%
              span.ml-2.text-sm + IVA
          b-button.my-3(variant="primary", size="lg", :to="{name: 'Plans'}") Ver todos los planes
          p.text-secondary.text-sm * La conexión con Whatsapp tiene un costo extra por servicio al mes
    billing(:billing="activePlan", :plan="plan")
    b-button.text-dark.text-underline(variant="link", :to="{name: 'History'}", v-if="morePlans") Ver todos mis planes activos
    empty-message(message="No hay suscripciones en esta cuenta", v-if="!billings")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const planController = createNamespacedHelpers('plan')

import Billing from '@/components/Billing.vue'

export default {
  data () {
    return {
      billings: [],
      plan: null
    }
  },
  computed: {
    ...planController.mapState({
      plans: state => state.plans
    }),
    morePlans () {
      return this.billings.slice(1).length >= 1
    },
    activePlan () {
      //return this.billings.slice(0,1)[0]
      return this.billings.find(p => p.status == 'Active')
    },
  },
  methods: {
    ...mapActions(['account/billings', 'plan/get']),
    getAccountBilling() {
      let self = this
      // this.showLoadingScreen()

      this['account/billings']({
        account_id: self.$route.params.account_id,
        status: 'Active',
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            res.resource.forEach(bill => {
              let expire_date = self.$moment(bill.start_date).add(bill.billed_days, 'days'),
                diff_days = self.$moment().diff(expire_date, 'days'),
                diff_months = self.$moment().diff(expire_date, 'months'),
                diff_years = self.$moment().diff(expire_date, 'years')

              bill.should_renew = true
              bill.end_date = expire_date

              if (diff_days == 0) { // is today
                bill.expire_date_string = 'Hoy vence tu plan'
              } else if (diff_days < 0) { // is in the future
                if ((diff_days * -1) > 10)
                  bill.should_renew = false

                if ((diff_days * -1) > 730) { // min 2 years
                  bill.expire_date_string = `Vence en ${diff_years * -1} años`
                } else if ((diff_days * -1) > 62) { // min 2 months
                  bill.expire_date_string = `Vence en ${diff_months * -1} meses`
                } else { // days left
                  bill.expire_date_string = `Vence en ${diff_days * -1} días`
                }
              } else { // is in the past
                bill.expire_date_string = `Terminó hace ${diff_days} días`
              }

              self.billings.push(bill)
            })
            if (this.activePlan != null)
              self.getPlan()
          }
        }
      })
    },
    getPlan () {
      let self = this
      this['plan/get']({
        ...self.activePlan,
        callback: res => {
          if (res.error) {
            // self.$message.error(res.error)
          } else {
            self.plan = res.resource
          }
        }
      })
    },
    /*plan (plan_id) {
      return this.plans.find(p => p.plan_id == (plan_id || 0))
    },*/
  },
  mounted () {
    this.getAccountBilling()
  },
  components: {
    Billing
  }
}
</script>

<style lang="scss" scoped>
</style>
